import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  sidePanel: {
    width: 305,
  },
  bottomPanel: {
    width: "auto",
  },
  drawerContent: {
    height: "100vh",
    "-webkit-overflow-scrolling": "touch",
    overflowY: "scroll",
  },
  customDrawerContent: {
    height: "calc(100vh - 40px)",
  },
  rootClass: {
    height: "calc(100% - 40px)",
    top: 40,
  },
}));

export default useStyles;
